function openBackStock(variantId) {
  // open popup to request email
  const backStockPopup = document.querySelector('#back-stock-popup');
  backStockPopup.classList.remove('back-stock-popup--hide');

  //copy variant id to hidden input
  const variantIdInput = document.querySelector('#popup_variant_id');
  if (variantIdInput) {
    variantIdInput.value = variantId;
  }

  //add event listener for escape key to close popup
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      closeBackStockPopup();
    }
  });
}

function closeBackStockPopup() {
  const backStockPopup = document.querySelector('#back-stock-popup');
  backStockPopup.classList.add('back-stock-popup--hide');

  const form = document.querySelector('.back-stock-popup__div');
  if (form) {
    form.classList.remove('back-stock-popup--hide');
  }
  const sentMessage = document.querySelector('.back-stock-popup__sent');
  if (sentMessage) {
    sentMessage.classList.add('back-stock-popup--hide');
  }

  //remove event listener for escape key to close popup
  document.removeEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      closeBackStockPopup();
    }
  });
}

async function sendBackStock() {
  // validate email input
  let errorFound = false;
  const emailInput = document.querySelector('#email-back-stock');
  let email = emailInput.value;
  const emailError = document.querySelector('#back-stock-popup__error');
  const emailErrorAPI = document.querySelector('#back-stock-popup__error-api');
  let variantId = document.querySelector('#popup_variant_id');
  if (variantId) {
    variantId = variantId.value;
  } else {
    email = '';
    closeBackStockPopup();
    errorFound = true;
    return;
  }
  // validate email using regex
  const emailRegex = /\S+@\S+\.\S+/;

  if (!email || !emailRegex.test(email)) {
    emailError.classList.remove('back-stock-popup--hide');
    errorFound = true;
    return;
  } else {
    emailError.classList.add('back-stock-popup--hide');
    const form = document.querySelector('.back-stock-popup__div');
    const sentMessage = document.querySelector('.back-stock-popup__sent');
    if (form) {
      // send fetch to Klaviyo

      const options = {
        method: 'POST',
        headers: {
          accept: 'application/json',
          revision: '2023-12-15',
          'content-type': 'application/json',
        },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                  },
                },
              },
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${variantId}`,
                },
              },
            },
          },
        }),
      };

      const klaviyoFetch = await fetch(
        'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=WxqJ98',
        options
      )
        .then((response) => {
          try {
            if (response && response.status !== 202) {
              emailErrorAPI.classList.remove('back-stock-popup--hide');
              errorFound = true;
              return;
            }
            return response && response.length ? response.json() : '';
          } catch (err) {
            console.error('err', err);
            return '';
          }
        })
        .then((response) => {
          if (response.errors) {
            emailErrorAPI.classList.remove('back-stock-popup--hide');
            errorFound = true;
            return;
          }
        })
        .catch((err) => {
          emailErrorAPI.classList.remove('back-stock-popup--hide');
          console.error('err', err);
          return;
        });

      // reset all values
      if (!errorFound) {
        form.classList.add('back-stock-popup--hide');
        sentMessage.classList.remove('back-stock-popup--hide');
        setTimeout(function() {
          email = '';
          closeBackStockPopup();
        }, 4000);
      }
    }
  }
}


function expandImages() {
  const imageContainer = document.querySelectorAll('.show-more-images__wrapper .image-wrapper');
  imageContainer.forEach((container) => {
    container.classList.toggle('image-wrapper--more--hide-padding');
  });

  const expandButton = document.querySelector('.show-more-images');
  expandButton.classList.toggle('show-more-images--expanded');

  const expandButton2 = document.querySelector('.show-more-images--close');
  expandButton2.classList.toggle('show-more-images--expanded');
}